import { Link } from "react-router-dom";
import { MapPin, Home, Maximize, BedDouble } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function PropertyCard({ property }) {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(price);
  };

  return (
    <Link 
      to={`/bien/${property.reference}`}
      className="group block property-card bg-white border border-zinc-200 overflow-hidden"
      data-testid={`property-card-${property.reference}`}
    >
      {/* Image */}
      <div className="relative aspect-[4/3] overflow-hidden bg-zinc-100">
        {property.images && property.images.length > 0 ? (
          <img 
            src={property.images[0]} 
            alt={property.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-zinc-200">
            <Home className="h-12 w-12 text-zinc-400" />
          </div>
        )}
        
        {/* Badge Type */}
        <div className="absolute top-3 left-3">
          <Badge className="bg-zinc-900 text-white text-xs uppercase tracking-wider px-3 py-1 rounded-none">
            {property.property_type}
          </Badge>
        </div>

        {/* DPE Badge */}
        {property.dpe_class && (
          <div className="absolute top-3 right-3">
            <span className={`dpe-${property.dpe_class} text-xs font-bold px-2 py-1`}>
              DPE {property.dpe_class}
            </span>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-5">
        {/* City */}
        <div className="flex items-center gap-1.5 text-zinc-500 text-sm mb-2">
          <MapPin className="h-3.5 w-3.5 text-[#00B5AD]" />
          <span>{property.city}</span>
          {property.postal_code && (
            <span className="text-zinc-400">({property.postal_code})</span>
          )}
        </div>

        {/* Title */}
        <h3 className="font-['Outfit'] font-medium text-lg text-zinc-900 mb-3 line-clamp-2 group-hover:text-[#D62965] transition-colors">
          {property.title}
        </h3>

        {/* Features */}
        <div className="flex items-center gap-4 text-sm text-zinc-600 mb-4">
          <div className="flex items-center gap-1.5">
            <Maximize className="h-4 w-4 text-[#00B5AD]" />
            <span>{property.surface} m²</span>
          </div>
          {property.bedrooms > 0 && (
            <div className="flex items-center gap-1.5">
              <BedDouble className="h-4 w-4 text-[#00B5AD]" />
              <span>{property.bedrooms} ch.</span>
            </div>
          )}
          {property.rooms > 0 && (
            <div className="flex items-center gap-1.5">
              <Home className="h-4 w-4 text-[#00B5AD]" />
              <span>{property.rooms} pièces</span>
            </div>
          )}
        </div>

        {/* Price */}
        <div className="flex items-end justify-between">
          <p className="font-['Outfit'] text-2xl font-bold text-zinc-900 tracking-tight">
            {formatPrice(property.price)}
          </p>
          <span className="text-xs text-zinc-400">Réf: {property.reference}</span>
        </div>
      </div>
    </Link>
  );
}
